import { createSlice } from "../helper";

const initialState = {
  options: null,
  role:null,
  tab:null,
  funnelData:{},
  userGraphData: {},
  connectionGraphData: {},
  tableData:{}
};

const detailedConnectionOutcomesSlice = createSlice({
  name: 'DetailedConnectionOutcomes',
  initialState,
  reducers: {
    updateOptions: (state, action) => {
      state.options = action.payload;
    },
    updateRole: (state, action) => {
      state.role = action.payload;
    },
    updateTab: (state, action) =>{
      state.tab = action.payload;
    },
    updateFunnelData: (state, action) => {
      state.funnelData = action.payload;
    },
    updateUserGraphData: (state, action) => {
      state.userGraphData = action.payload;
    },
    updateConnectionGraphData: (state, action) => {
      state.connectionGraphData = action.payload;
    },
    updateAllGraphData: (state, action) => {
      state.userGraphData = action.payload.userGraphData;
      state.connectionGraphData = action.payload.connectionGraphData;
    },
    updateTableData: (state, action) => {
      state.tableData = action.payload;
    },
    appliedFilters: (state, action) => {
      state.appliedFilters = action.payload
    }
  }
});

export const detailedConnectionOutcomesActions =  detailedConnectionOutcomesSlice.actions;

export default detailedConnectionOutcomesSlice;
